
export const SidebarHeader = () => {
	return (
		<div className="pt-4 pb-10 px-4 text-neutral-500">
			Predictty
		</div>
	)
}

